import React, { memo, useEffect, useState } from "react";
import toastr from "toastr";
import { useDispatch, useSelector } from "react-redux";
import {
  addPrintRequest,
  addPrintTranasction,
  getPaymentIntent,
} from "store/actions";
import moment from "moment";
import { Oval } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

// ✅ Helpers
function calPercentAmt(percentage = 25, amount = 100) {
  return ((percentage / 100) * amount).toFixed(6);
}

const formatDate = (date) =>
  date ? moment(date).utcOffset(330).format("DD MMM YYYY hh:mm A") : "---";

const formatDateAddDays = (date) =>
  date
    ? moment(date).add(7, "days").utcOffset(330).format("DD MMM YYYY hh:mm A")
    : "---";

const adminPercent = process.env.REACT_APP_ADMIN_PRINT_PERCENT;
const artistPercent = process.env.REACT_APP_ARTIST_PRINT_PERCENT;
const dealerPercent = 125;

function PaywithCard({
  amount,
  onClose,
  totalPrice,
  dealerCode,
  printInfo,
  ownerId,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state?.Login);
  const PrintLoading = useSelector((state) => state?.Print?.loading);

  const [cardNumber, setCardNumber] = useState("");
  const [expMonth, setExpMonth] = useState("");
  const [expYear, setExpYear] = useState("");
  const [cvv, setCvv] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAcceptReady, setIsAcceptReady] = useState(false);
  const [txId, setTxId] = useState("");

  // ✅ Check Accept.js loaded
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.Accept && window.Accept.dispatchData) {
        setIsAcceptReady(true);
        clearInterval(interval);
      }
    }, 300);

    setTimeout(() => clearInterval(interval), 10000);

    return () => clearInterval(interval);
  }, []);

  // ✅ Print request data
  const adminCharge = Number(adminPercent) + (dealerCode ? 0 : 30);
  const sellerCharge = Number(artistPercent) + (dealerCode ? 0 : 95);

  const printRequestData = {
    ...printInfo,
    total_cost: totalPrice + (printInfo?.premium_charge || 0),
    admin_earning: calPercentAmt(
      adminCharge,
      printInfo?.printer_alone_charge
    ),
    seller_earning: calPercentAmt(
      sellerCharge,
      printInfo?.printer_alone_charge
    ),
    printer_earning: printInfo?.printer_alone_charge,
    dealer_earning: dealerCode
      ? calPercentAmt(dealerPercent, printInfo?.printer_alone_charge)
      : 0,
    order_received_date: formatDate(new Date()),
    due_date: formatDateAddDays(new Date()),
    owner_id: ownerId,
    user_id: user?._id,
    nft_id: printInfo?.nft_id,
  };

  // ✅ Payment Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isAcceptReady) {
      toastr.error("Payment system not ready. Refresh page.");
      return;
    }

    if (!cardNumber || !expMonth || !expYear || !cvv) {
      toastr.error("Please fill all card details");
      return;
    }

    if (cardNumber.length < 13) {
      toastr.error("Invalid card number");
      return;
    }

    setLoading(true);

    const authData = {
      clientKey: process.env.REACT_APP_CLIENT_KEY,
      apiLoginID: process.env.REACT_APP_API_LOGIN_ID,
    };

    const cardData = {
      cardNumber,
      month: expMonth,
      year: expYear,
      cardCode: cvv,
    };

    window.Accept.dispatchData({ authData, cardData }, (response) => {
      if (response.messages.resultCode === "Error") {
        const errorMsg = response.messages.message[0].text;
        toastr.error(errorMsg);
        setLoading(false);
        return;
      }

      // ✅ Clear sensitive data immediately
      setCardNumber("");
      setExpMonth("");
      setExpYear("");
      setCvv("");
dispatch(
  getPaymentIntent(
    {
      amount: amount,
      opaqueData: response.opaqueData,
    },
    (res) => {
      console.log("Payment response:", res);

      if (res.status === "success") {
        setTxId(res.data);

        dispatch(
          addPrintRequest(
            { txn_id: res.data, ...printRequestData },
            (res1) => {
              if (res1.status === "success") {
                toastr.success("Payment successful");
                navigate("/profile/printrequest");
              } else {
                toastr.error("Failed to create request");
              }
            }
          )
        );

        onClose();
      } else {
        toastr.error(res.message || "Transaction failed");
      }

      setLoading(false);
    }
  )
);

      // dispatch(
      //   getPaymentIntent(
      //     {
      //       amount: amount, // ✅ FIXED
      //       opaqueData: response.opaqueData,
      //     },
      //     (res) => {
      //       if (res.status === "success") {
      //         setTxId(res.data);

      //         dispatch(
      //           addPrintRequest(
      //             { txn_id: res.data, ...printRequestData },
      //             (res1) => {
      //               if (res1.status === "success") {
      //                 toastr.success("Payment successful");
      //                 navigate("/profile/printrequest");
      //               } else {
      //                 toastr.error("Failed to create request");
      //               }
      //             }
      //           )
      //         );

      //         onClose();
      //       } else {
      //         toastr.error("Transaction failed this one");
      //       }

      //       setLoading(false);
      //     }
      //   )
      // );
    });
  };

  return (
    <>
      {PrintLoading && (
        <div className="loaderBoxMiane">
          <Oval height={60} width={60} visible={true} />
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <h3>Pay with Credit Card</h3>

        <input
          className="form-control mb-2"
          placeholder="Card Number"
          value={cardNumber}
          onChange={(e) => setCardNumber(e.target.value)}
        />

        <div className="d-flex gap-2">
          <input
            className="form-control"
            placeholder="MM"
            value={expMonth}
            onChange={(e) => setExpMonth(e.target.value)}
          />
          <input
            className="form-control"
            placeholder="YYYY"
            value={expYear}
            onChange={(e) => setExpYear(e.target.value)}
          />
          <input
            className="form-control"
            placeholder="CVV"
            value={cvv}
            onChange={(e) => setCvv(e.target.value)}
          />
        </div>

        <button
          className="btn btn-primary mt-3"
          type="submit"
          disabled={loading}
        >
          {loading ? "Processing..." : "Pay Now"}
        </button>
      </form>
    </>
  );
}

export default memo(PaywithCard);




// import React, { memo, useEffect, useState } from "react";
// import toastr from "toastr";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addPrintRequest,
//   addPrintTranasction,
//   getPaymentIntent,
// } from "store/actions";
// import moment from "moment";
// import { Oval } from "react-loader-spinner";
// import { useNavigate } from "react-router-dom";

// function calPercentAmt(percentage = 25, amount = 100, type) {
//   console.log("calperAmount", type, percentage, amount);
//   return ((percentage / 100) * amount).toFixed(6);
// }
// const formatDate = (date) =>
//   date ? moment(date).utcOffset(330).format("DD MMM YYYY hh:mm A") : "---";

// const formatDateAddDays = (date) =>
//   date
//     ? moment(date).add(7, "days").utcOffset(330).format("DD MMM YYYY hh:mm A")
//     : "---";
// const taxPercent = process.env.REACT_APP_PINTER_TAX_PERCENT;
// const adminPercent = process.env.REACT_APP_ADMIN_PRINT_PERCENT;
// const artistPercent = process.env.REACT_APP_ARTIST_PRINT_PERCENT;
// const printerPercent = process.env.REACT_APP_PINTER_PRINT_PERCENT;
// const dealerPercent = 125;
// function PaywithCard({
//   amount,
//   onClose,
//   totalPrice,
//   dealerCode,
//   nftid,
//   printInfo,
//   ownerId,
// }) {
//   const navigate = useNavigate();
//   const [cardNumber, setCardNumber] = useState("");
//   const [expMonth, setExpMonth] = useState("");
//   const [expYear, setExpYear] = useState("");
//   const [cvv, setCvv] = useState("");
// const [loading, setLoading] = useState(false);
//   const [isAcceptJsReady, setIsAcceptJsReady] = useState(false);
//   const [acceptInitError, setAcceptInitError] = useState(null);
//   const dispatch = useDispatch();
//   const { user, settings } = useSelector((state) => state?.Login);
//   const PrintLoading = useSelector((state) => state?.Print?.loading);
//   // const {  printInfo , saledata} = data
//   const [txId, setTxId] = useState("");
//   useEffect(() => {
//     console.log("printInfo", printInfo);
//   }, [printInfo]);

//   // Wait for Accept.js to load and initialize
//   useEffect(() => {
//     let timeoutId;
    
//     const checkAcceptJs = () => {
//       if (window.Accept && typeof window.Accept.init === 'function') {
//         try {
//           window.Accept.init({
//             apiLoginID: process.env.REACT_APP_API_LOGIN_ID,
//             clientKey: process.env.REACT_APP_CLIENT_KEY,
//             environment: 'production' // Use 'sandbox' for testing
//           });
//           setIsAcceptJsReady(true);
//           setAcceptInitError(null);
//           console.log('✅ Accept.js initialized successfully');
//         } catch (error) {
//           console.error('❌ Accept.js init error:', error);
//           setAcceptInitError(error.message);
//         }
//         return true;
//       }
//       return false;
//     };

//     // Check immediately
//     if (checkAcceptJs()) return;

//     // Poll every 500ms, timeout after 20s
//     const interval = setInterval(() => {
//       if (checkAcceptJs()) {
//         clearInterval(interval);
//       }
//     }, 500);

//     timeoutId = setTimeout(() => {
//       clearInterval(interval);
//       setAcceptInitError('Payment library timeout. Please refresh and try again.');
//     }, 20000);

//     return () => {
//       clearInterval(interval);
//       clearTimeout(timeoutId);
//     };
//   }, []);
//   const addPrintCallback = (res) => {
//     if (res.status === "success") {
//       let printTransData = {};
//       let adminCharge = Number(adminPercent) + (Number(dealerCode) ? 0 : 30);
//       let sellerCharge = Number(artistPercent) + (Number(dealerCode) ? 0 : 95);
//       let delarCharge = Number(dealerPercent);
//       printTransData.admin_earning = calPercentAmt(
//         adminCharge,
//         printInfo?.printer_alone_charge,
//         "adminRarnign"
//       );
//       printTransData.seller_earning = calPercentAmt(
//         sellerCharge,
//         printInfo?.printer_alone_charge,
//         "asellerRarnign"
//       );
//       printTransData.printer_earning = printInfo?.printer_alone_charge;
//       printTransData.dealer_earning = dealerCode
//         ? calPercentAmt(
//             delarCharge,
//             printInfo?.printer_alone_charge,
//             "dealerEarning"
//           )
//         : 0;
//       printTransData.print_request_id = res.data._id;
//       printTransData.total_amount = amount;
//       printTransData.premium_amount = 0;
//       printTransData.payment_status = "Completed";
//       printTransData.status = "Completed";
//       printTransData.nft_id = printInfo?.nft_id;
//       printTransData.user_id = user?._id;
//       printTransData.seller_id = ownerId;
//       printTransData.buyer_id = user?._id;
//       printTransData.tx_id = txId;
//       dispatch(
//         addPrintTranasction(
//           printTransData,

//           (res1) => {
//             //  console.log("parshant ki jai",res1)
//             if (res1.status === "success") {
//               toastr.success("Print Request have done successfully");
//               return navigate("/profile/printrequest");
//             } else {
//               return toastr.error("Something went wrong");
//             }
//           }
//         )
//       );
//     } else {
//       toastr.error("Error in Print Request");
//     }
//   };
//   const adminCharge = Number(adminPercent) + (dealerCode ? 0 : 30);
//   const sellerCharge = Number(artistPercent) + (dealerCode ? 0 : 95);
//   const printerCharge = Number(printInfo?.printer_alone_charge); // use printerPercent, not full print_charge
//   const dealerCharge = dealerCode ? 125 : 0;

//   const printRequestData = {
//     ...printInfo,
//     total_cost: totalPrice + printInfo.premium_charge,
//     admin_earning: calPercentAmt(
//       adminCharge,
//       printInfo?.printer_alone_charge,
//       "adminEarning"
//     ),
//     seller_earning: calPercentAmt(
//       sellerCharge,
//       printInfo?.printer_alone_charge,
//       "sellerEarning"
//     ),
//     printer_earning: printInfo?.printer_alone_charge,
//     dealer_earning: dealerCode
//       ? calPercentAmt(
//           dealerCharge,
//           printInfo?.printer_alone_charge,
//           "dealerEarning"
//         )
//       : 0,
//     order_received_date: formatDate(new Date()),
//     due_date: formatDateAddDays(new Date()),
//     owner_id: ownerId,
//     user_id: user?._id,
//     nft_id: printInfo?.nft_id,
//     dealerCode: printInfo?.dealerCode || "",
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     if (!isAcceptJsReady) {
//       toastr.error(acceptInitError || "Payment library still loading...");
//       return;
//     }

//     if (!window.Accept?.dispatchData) {
//       toastr.error("Payment library not ready. Please refresh and try again.");
//       return;
//     }

//     setLoading(true);
//     const authData = {
//       clientKey: process.env.REACT_APP_CLIENT_KEY,
//       apiLoginID: process.env.REACT_APP_API_LOGIN_ID,
//     };
//     const cardData = {
//       cardNumber,
//       month: expMonth,
//       year: expYear,
//       cardCode: cvv,
//     };
//     const secureData = { authData, cardData };

//     window.Accept.dispatchData(secureData, (response) => {
//       console.log("response before ",response )
//       if (response.messages.resultCode === "Error") {
//         toastr.error("Wrong Credit Card details.");
//         // alert(response.messages.message[0].text);
//         setLoading(false);
//       } else {
//         const getPaymentIntentcallback = (res) => {
//           console.log("response callback ",res )
//           if (res.status === "success") {
//             setTxId(res.data);
//             dispatch(
//               addPrintRequest(
//                 { txn_id: res.data, ...printRequestData },
//                 addPrintCallback
//               )
//             );

//             setLoading(false);
//             onClose();
//           } else {
//             console.log("error", res);
//             toastr.error("Transaction Failed.");
//             setLoading(false);
//           }
//         };
//         dispatch(
//           getPaymentIntent(
//             {
//               amount: totalPrice,
//               opaqueData: response.opaqueData,
//             },
//             getPaymentIntentcallback
//           )
//         );
//       }
//     });
//   };

//   return (
//     <>
//       {PrintLoading && (
//         <div className="loaderBoxMiane">
//           <Oval
//             height={80}
//             width={80}
//             color="#6C63FF"
//             wrapperStyle={{}}
//             wrapperClass=""
//             visible={true}
//             ariaLabel="oval-loading"
//             secondaryColor="#6C63FF"
//             strokeWidth={2}
//             strokeWidthSecondary={2}
//           />
//         </div>
//       )}
//       <form onSubmit={handleSubmit} className="text-start">
//         <h3 className="mb-3">Pay with Credit Card</h3>
//         <input
//           className="form-control mb-2"
//           placeholder="​​​​​​​Enter credit card number"
//           value={cardNumber}
//           onChange={(e) => setCardNumber(e.target.value)}
//           required
//         />
//         <div className="d-flex gap-2">
//           <input
//             className="form-control mb-2"
//             placeholder="Enter expiry month (MM)"
//             value={expMonth}
//             onChange={(e) => setExpMonth(e.target.value)}
//             required
//           />
//           <input
//             className="form-control mb-2"
//             placeholder="Enter expiry year (YYYY)"
//             value={expYear}
//             onChange={(e) => setExpYear(e.target.value)}
//             required
//           />
//           <input
//             className="form-control mb-2"
//             placeholder="Enter CVV (i.e. 123)"
//             value={cvv}
//             onChange={(e) => setCvv(e.target.value)}
//             required
//           />
//         </div>
//         {acceptInitError && (
//           <div className="alert alert-danger mt-3">
//             {acceptInitError}
//             <button 
//               type="button" 
//               className="btn btn-sm btn-outline-danger ms-2"
//               onClick={() => window.location.reload()}
//             >
//               Refresh Page
//             </button>
//           </div>
//         )}
        
//         {isAcceptJsReady ? (
//           <button
//             className="btn btn-primary mt-3"
//             type="submit"
//             disabled={loading || !isAcceptJsReady}
//           >
//             {loading ? "Processing..." : "Pay Now"}
//           </button>
//         ) : (
//           <div className="mt-3 text-center">
//             <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             Initializing secure payment...
//           </div>
//         )}
//       </form>
//     </>
//   );
// }

// export default memo(PaywithCard);
